import CookieStorage from './CookieStorage';

class TokenManager {
    static storage = new CookieStorage();

    static async saveTokens({ /*auth_token, auth_refresh_token, */session_token, session } = {}) {
        try {
            // ToDo: Cognito - disable
            // if (auth_token !== undefined) {
            //     await this.storage.setValue('auth_token', auth_token);
            // }
            //
            // if (auth_refresh_token !== undefined) {
            //     await this.storage.setValue('auth_refresh_token', auth_refresh_token);
            // }
            if (session_token !== undefined) {
                await this.storage.setValue('session_token', session_token);
            }

            if (session !== undefined) {
                await this.storage.setValue('session', session);
            }
        } catch (err) {
            console.warn('Failed to save tokens:', err);
        }
    }

    // static async getAccessToken() {
    //     try {
    //         return await this.storage.getValue('auth_token');
    //     } catch (err) {
    //         console.warn('Failed to get access token:', err);
    //         return null;
    //     }
    // }

    // static async getRefreshToken() {
    //     try {
    //         return await this.storage.getValue('auth_refresh_token');
    //     } catch (err) {
    //         console.warn('Failed to get refresh token:', err);
    //         return null;
    //     }
    // }

    static async getSessionToken() {
        try {
            return await this.storage.getValue('session_token');
        } catch (err) {
            console.warn('Failed to get session token:', err);
            return null;
        }
    }

    static async getSession() {
        try {
            return await this.storage.getValue('session');
        } catch (err) {
            console.warn('Failed to get session:', err);
            return null;
        }
    }

    static async removeTokens() {
        try {
            // ToDo: Cognito - disable
            // await this.storage.removeValue('auth_token');
            // await this.storage.removeValue('auth_refresh_token');
            await this.storage.removeValue('session_token');
            await this.storage.removeValue('session');
        } catch (err) {
            console.warn('Failed to remove tokens:', err);
        }
    }
}

export default TokenManager;
